import React from 'react';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import {connect} from 'react-redux';
import setExternalReleaseAction from '../../redux/actions/createReferenceActions/actionExternalRelease';

class ExternalRelease extends React.Component {
    constructor(props) {
        super(props);
        this.handleChangeSwitch = this.handleChangeSwitch.bind(this);
        if(this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
            this.state = {checked: JSON.parse(this.props.selectedReferenceData.externalRelease.toLowerCase()), externalRelease: true}
            this.props.setExternalReleaseFunktion(JSON.parse(this.props.selectedReferenceData.externalRelease.toLowerCase()))
        } else {
            this.state = {checked: false, externalRelease: false}
            this.props.setExternalReleaseFunktion('false')
        }
    }

        // Switch handler
        handleChangeSwitch = (event) => {
            // true/false
            this.setState({ [event.target.name]: event.target.checked, externalRelease: event.target.checked  }, () => {
                this.props.setExternalReleaseFunktion(this.state.externalRelease);
            });
        }

        

    render() {

        return (

            <Button style={{ width: 300, backgroundColor: 'rgba(19, 174, 236, 0.54)', marginBottom: '10px' }} variant="contained" color="primary" size="large" >
                External release?
                <Switch color="secondary" checked={this.state.checked} onChange={this.handleChangeSwitch} name="checked" />
            </Button>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setExternalReleaseFunktion: externalRelease => {
            dispatch(setExternalReleaseAction(externalRelease));
        }
    }
}
const mapStateToProps = state => {

    return {
        selectedReferenceData: state.showRefState.selectedReferenceData
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalRelease)